// Each leg's last view, remembered so that a link back to the leg returns to it: the tab for the
// other leg, and the form's way back after a save. The view is the leg's query string exactly as
// the URL showed it - the filters, the sort, the page - so nothing is interpreted here.
//
// Session storage, not component state: the tracker unmounts on the way to the form, and a row
// edited under a filter should land back under it. Session scope is the right one - a
// browser tab is a working session, a new tab starts on the default view, and a reload keeps
// its place. The URL is still the only thing read to show a leg; this is a memory of links.

const KEY_PREFIX = 'trex.deliveries.view.';

export function rememberView(leg, search, storage = sessionStorage) {
  if (search) storage.setItem(KEY_PREFIX + leg, search);
  else storage.removeItem(KEY_PREFIX + leg);
}

// The query string to append to `/deliveries/{leg}`: what the leg was last seen with, or nothing.
export function recallView(leg, storage = sessionStorage) {
  return storage.getItem(KEY_PREFIX + leg) ?? '';
}
